import React, { useMemo } from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { DEFAULT_ISSUE_NAME, LIFECYCLE_ACTIONS } from "../activity-types";

interface DefaultChangeChunkProps {
  change: ActivityChange;
}

export function DefaultChangeChunk({ change }: DefaultChangeChunkProps) {
  const fullText = useMemo(() => {
    if (!change.target.label || !change.action) return "";

    if (LIFECYCLE_ACTIONS.includes(change.action)) {
      return `${change.action} this ${DEFAULT_ISSUE_NAME.toLowerCase()}`;
    }

    const actionText = (() => {
      switch (change.action) {
        case "created":
          return "set";
        case "deleted":
          return "cleared";
        case "updated":
          return "updated";
        default:
          return change.action;
      }
    })();

    let beforeText = "";
    if (change.action === "updated" && change.oldValue?.value) {
      beforeText = ` from ${change.oldValue.value}`;
    }

    let afterText = "";
    if (
      (change.action === "updated" || change.action === "created") &&
      change.newValue?.value
    ) {
      afterText = ` to ${change.newValue.value}`;
    }

    const resultText =
      beforeText && afterText
        ? `${beforeText}${afterText}`
        : !beforeText && afterText
          ? afterText
          : "";

    return `${actionText} ${change.target.label}${resultText}`;
  }, [change]);

  return <Text size="sm">{fullText}</Text>;
}
